import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { toCurrency, toPercent } from "@helpers";
import { InvestmentsChartDataStatistic } from "@api/v1/hooks/performance/useInvestmentsChartData";
import { GainLossTypography } from "@components";
import {
  InvestmentsTableContainer,
  InvestmentsTableSummaryWrapper,
  GainLossTypographyBox,
  GainLossPercentsStyled,
  SummaryItem,
} from "./components";
import { InvestmentsTableSummaryMobile } from "./InvestmentsTableSummaryMobile";

export interface Props {
  statistic: InvestmentsChartDataStatistic;
}

export const InvestmentsTableSummary = ({ statistic }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down("md"));

  return (
    // @ts-ignore
    <InvestmentsTableContainer>
      <InvestmentsTableSummaryWrapper>
        {isMd ? (
          <InvestmentsTableSummaryMobile statistic={statistic} />
        ) : (
          <>
            <Box display="flex" flexDirection="row" gap={10}>
              <SummaryItem label={t("investmentsTable.summary.today")}>
                <Box display="flex">
                  <GainLossTypography
                    variant="subtitle2"
                    value={statistic.changeTodayAbs}
                  >
                    {toCurrency(statistic.changeTodayAbs, "EUR")}
                  </GainLossTypography>
                  &nbsp;
                  <GainLossTypography
                    variant="subtitle2"
                    value={statistic.changeToday}
                  >
                    ({toPercent(statistic.changeToday)})
                  </GainLossTypography>
                </Box>
              </SummaryItem>
              <SummaryItem label={t("investmentsTable.summary.purchaseValue")}>
                <GainLossTypography
                  variant="subtitle2"
                  value={statistic.investedCapital}
                >
                  {toCurrency(statistic.investedCapital, "EUR")}
                </GainLossTypography>
              </SummaryItem>
              <SummaryItem label={t("investmentsTable.summary.priceGains")}>
                <GainLossTypography
                  variant="subtitle2"
                  value={statistic.valuationGain}
                >
                  {toCurrency(statistic.valuationGain, "EUR")}
                </GainLossTypography>
              </SummaryItem>
            </Box>
            <Box>
              <GainLossTypographyBox>
                <Typography variant="h4" noWrap>
                  {toCurrency(statistic.portfolioValue, "EUR")}
                </Typography>
                <GainLossPercentsStyled
                  value={statistic.valuationGainPercent ?? 0}
                />
              </GainLossTypographyBox>
            </Box>
          </>
        )}
      </InvestmentsTableSummaryWrapper>
    </InvestmentsTableContainer>
  );
};
